var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9324 4.24125C17.4715 4.67251 17.5589 5.45912 17.1276 5.9982L9.32156 15.7558C9.08898 16.0465 8.73891 16.2184 8.36665 16.2247C7.9944 16.231 7.6387 16.0711 7.39641 15.7884L4.05095 11.8854C3.60167 11.3612 3.66238 10.5721 4.18653 10.1228C4.71069 9.67353 5.49982 9.73423 5.94909 10.2584L8.31227 13.0154L15.1754 4.43646C15.6067 3.89738 16.3933 3.80998 16.9324 4.24125Z",
    fill: "#70C43B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi45MzI0IDQuMjQxMjVDMTcuNDcxNSA0LjY3MjUxIDE3LjU1ODkgNS40NTkxMiAxNy4xMjc2IDUuOTk4Mkw5LjMyMTU2IDE1Ljc1NThDOS4wODg5OCAxNi4wNDY1IDguNzM4OTEgMTYuMjE4NCA4LjM2NjY1IDE2LjIyNDdDNy45OTQ0IDE2LjIzMSA3LjYzODcgMTYuMDcxMSA3LjM5NjQxIDE1Ljc4ODRMNC4wNTA5NSAxMS44ODU0QzMuNjAxNjcgMTEuMzYxMiAzLjY2MjM4IDEwLjU3MjEgNC4xODY1MyAxMC4xMjI4QzQuNzEwNjkgOS42NzM1MyA1LjQ5OTgyIDkuNzM0MjMgNS45NDkwOSAxMC4yNTg0TDguMzEyMjcgMTMuMDE1NEwxNS4xNzU0IDQuNDM2NDZDMTUuNjA2NyAzLjg5NzM4IDE2LjM5MzMgMy44MDk5OCAxNi45MzI0IDQuMjQxMjVaIiBmaWxsPSIjNzBDNDNCIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };